import { Quotebox } from '@/components/Quotebox';
import { LabradorComponent } from '@/types/component';

export const LabradorQuotebox: LabradorComponent = ({ type, meta, data }) => {
  return <Quotebox data-content-index={meta.contentIndex} author={data.author} quote={data.quote} />;
};
